(function () {
    'use strict';
    angular
        .module('vhols', [
            'vholsPostCodeAnywhere',
            'ui.bootstrap',
            'ngTouch',
            'angular-inview',
            'LocalStorageModule',
            'vholsHeaderFooterDirectives',
            'vholsTracking',
            'vhols-dates',
            'vholsLightBox',
            'vholsIframeLb',
            'vhols-date-select-list',
            'ngSanitize',
            'vhols-date-input'
        ])
        .config(function ($locationProvider) {
            $locationProvider.html5Mode(true);
        });
    window.svg4everybody();
})();
